/**
 * Username validation rules:
 * - Only lowercase letters (a-z) and numbers (0-9)
 * - No spaces, hyphens, underscores or special characters
 * - Min 3, max 20 characters
 * - Must start with a letter
 */

const USERNAME_REGEX = /^[a-z][a-z0-9]{2,19}$/;

/** Sanitize input: lowercase, strip invalid chars */
export function sanitizeUsername(value: string): string {
  return value.toLowerCase().replace(/[^a-z0-9]/g, '');
}

/** Check if username matches all format rules */
export function isValidUsername(username: string): boolean {
  return USERNAME_REGEX.test(username);
}

/** Get a human-readable error, or null if valid */
export function getUsernameError(username: string): string | null {
  if (username.length === 0) return null;
  if (username.length < 3) return 'Mínimo 3 caracteres';
  if (username.length > 20) return 'Máximo 20 caracteres';
  if (!/^[a-z]/.test(username)) return 'Deve começar com uma letra';
  if (!/^[a-z][a-z0-9]*$/.test(username)) return 'Apenas letras e números';
  return null;
}
